import PropTypes from 'prop-types'
import { Icon } from '@iconify/react'
import { useEffect, useRef, useState } from 'react'
import ReactDOM from 'react-dom'
import QRCode from 'react-qr-code'
import ReactToPrint, { useReactToPrint } from 'react-to-print'
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill'
import { PrintOutlined, QrCode2 } from '@material-ui/icons'
// material
import { useTheme } from '@material-ui/core/styles'
import {
  Menu,
  MenuItem,
  IconButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Tooltip,
  Grid,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Input,
  Stack,
  Box
} from '@material-ui/core'
import { useNavigate } from 'react-router'
import { useSnackbar } from 'notistack'
import { PATH_DASHBOARD } from 'src/routes/paths'
import { BASE_URL, COMPANY_NAME, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { empty } from 'src/Helpers/Common'
import Modal from './ProjectModel'
import axios from 'axios'

const labelStyle = {
  width: '62mm',
  height: '20mm',
  // padding: '1mm',
  fontFamily: 'Arial, sans-serif', fontSize: '10px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', boxSizing: 'border-box', gap: '2mm', 
  overflow: 'hidden', 
  // pageBreakInside: 'avoid',
  // breakInside: 'avoid',
  pageBreakInside: 'avoid',
  breakInside: 'avoid',
  pageBreakBefore: 'avoid',
  flexWrap: 'nowrap',
  transform: 'scale(0.9)', /* Reducing size slightly */
  // border:"2px solid black",
  paddingRight:"12px",
  // paddingLeft:"1px",
  paddingTop:"10px"

};
const labelStyle1 = {
  width: '0.9in',
  height: '0.8in',
  // padding: '1mm',
  fontFamily: 'Arial, sans-serif',
  fontSize: '8px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  // gap: '1mm',
  overflow: 'hidden',
  // border:"2px solid black",

};

const rowStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
  gap: 2
};

const rowStyle1 = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  marginTop:"5px"
};

const sectionStyle = {
  display: 'flex',
  flexDirection: 'column',
};

const qrCodeSection = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // gap: '1mm',
};
const qrCodeSectionNew = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  // gap: '1mm',
  marginLeft:"5px"
};

const typographyStyle = {
  fontWeight: 'bold',
  textAlign: 'center',
  color: 'black',
  fontSize: '8px',
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-all',
};
const typographyStyleForDesc = {
  fontWeight: 'bold',
  textAlign: 'center',
  color: 'black',
  fontSize: '8px',
  overflow: 'hidden',
  display: '-webkit-box',
  WebkitLineClamp: 2,     
  WebkitBoxOrient: 'vertical',
};

// const typographyStyle1 = {
//   textAlign: 'center',
//   color: 'black',
//   fontSize: '6px',
//   wordWrap: 'break-word',
//   overflow: 'hidden',
//   textOverflow: 'ellipsis',
//   wordBreak: 'break-all',
// };

const typographyStyle1 = {
  textAlign: 'center',
  color: 'black',
  fontSize: '6px',
  maxWidth: '100%', // Prevents overflow
  wordWrap: 'break-word',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  wordBreak: 'break-word',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center', 
  padding:"2px"
  // height: '100%' // Ensure it takes full height for proper centering
};


export default function FinishedProductmenu({ id, url, useIcon, name, barcode,vpt_number ,description, vendor=null, partial=false, printerSettings=false}) {
  const ref = useRef(null)
  const componentRef = useRef(null)
  const detailsRef = useRef(null);
  const iframeRef = useRef(null);
  const smallIframeRef = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  let user = JSON.parse(localStorage.getItem('user'))
  const [openLabelModal, setOpenLabelModal] = useState(false);
  const [openSmallLabelModal, setOpenSmallLabelModal] = useState(false);
  
  // Hooks for direct printing when printerSettings is false
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  
  const handleSmallPrint = useReactToPrint({
    content: () => detailsRef.current,
  });
  
  const [labelSettings, setLabelSettings] = useState({
    scale: 0.9,
    paddingTop: 10,
    paddingRight: 12,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    qrSize: 45,
    width: '2.44',
    height: '0.79',
    pageWidth: '8.27',
    pageHeight: '11.69',
    titleFontSize: 8,
    skuFontSize: 7,
  });
  
  const [smallLabelSettings, setSmallLabelSettings] = useState({
    scale: 1,
    qrSize: 50,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    width: '0.9',
    height: '0.8',
    pageWidth: '8.27',
    pageHeight: '11.69',
    smallTitleFontSize: 6,
  });

// const mmToPx = (mm) => Math.round(parseFloat(mm || 0) * 3.78);
// const iframeWidth = mmToPx(labelSettings.pageWidth);
// const iframeHeight = mmToPx(labelSettings.pageHeight);
// const iframeWidthSmall = mmToPx(smallLabelSettings.pageWidth);
// const iframeHeightSmall = mmToPx(smallLabelSettings.pageHeight);

const inToPx = (inch) => Math.round(parseFloat(inch || 0) * 96);
const iframeWidth = inToPx(labelSettings.pageWidth);
const iframeHeight = inToPx(labelSettings.pageHeight);
const iframeWidthSmall = inToPx(smallLabelSettings.pageWidth);
const iframeHeightSmall = inToPx(smallLabelSettings.pageHeight);


  const updateIframeContent = () => {
    const iframe = iframeRef.current;
    const content = componentRef.current;
  
    if (iframe && content) {
      const doc = iframe.contentWindow.document;
      const html = `
        <html>
          <head>
            <style>
              @page {
                size: ${labelSettings.pageWidth}in ${labelSettings.pageHeight}in;
                margin: 0;
              }
              html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                background: white;
                font-family: Arial, sans-serif;
                overflow:auto;
              }
              .label {
              position: absolute;
              top: ${labelSettings.marginTop}px;
              left: ${labelSettings.marginLeft}px;
              transform: scale(${labelSettings.scale});
              transform-origin: top left;
              padding-top: ${labelSettings.paddingTop}px;
              padding-right: ${labelSettings.paddingRight}px;
              padding-bottom: ${labelSettings.paddingBottom}px;
              padding-left: ${labelSettings.paddingLeft}px;
              width: ${labelSettings.width}in;
              height: ${labelSettings.height}in;
}
            </style>
          </head>
          <body>
            <div class="label">${content.outerHTML}</div>
          </body>
        </html>
      `;
      doc.open();
      doc.write(html);
      doc.close();
    }
  };

  const updateSmallIframeContent = () => {
    const iframe = smallIframeRef.current;
    const content = detailsRef.current;
  
    if (iframe && content) {
      const doc = iframe.contentWindow.document;
      const html = `
        <html>
          <head>
            <style>
              @page {
                size: ${smallLabelSettings.pageWidth}in ${smallLabelSettings.pageHeight}in;
                margin: 0;
              }
              html, body {
                margin: 0;
                padding: 0;
                width: 100%;
                height: 100%;
                background: white;
                font-family: Arial, sans-serif;
                overflow:auto;
              }
              .label {
              position: absolute;
              top: ${smallLabelSettings.marginTop}px;
              left: ${smallLabelSettings.marginLeft}px;
              transform: scale(${smallLabelSettings.scale});
              transform-origin: top left;
              padding-top: ${smallLabelSettings.paddingTop}px;
              padding-right: ${smallLabelSettings.paddingRight}px;
              padding-bottom: ${smallLabelSettings.paddingBottom}px;
              padding-left: ${smallLabelSettings.paddingLeft}px;
              width: ${smallLabelSettings.width}in;
              height: ${smallLabelSettings.height}in;
            }
            </style>
          </head>
          <body>
            <div class="label">${content.outerHTML}</div>
          </body>
        </html>
      `;
      doc.open();
      doc.write(html);
      doc.close();
    }
  };

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}print/get-main-label-settings`);
        if (res.data.status === 1) {
          setLabelSettings(prev => ({
            ...prev,
            ...res.data.result
          }));
        }
      } catch (error) {
        enqueueSnackbar('Failed to load settings', { variant: 'error' });
      }
    };
  
    fetchSettings();
  }, [openLabelModal]);

  useEffect(() => {
    if (openSmallLabelModal) {
      const timeout = setTimeout(updateSmallIframeContent, 300);
      return () => clearTimeout(timeout);
    }
  }, [openSmallLabelModal, smallLabelSettings]);
  
  const saveSettings = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}print/update-settings`,{values:labelSettings});
      if(res.data.status === 1) {
        setOpenLabelModal(false);
      enqueueSnackbar('Settings saved successfully!', { variant: 'success' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to save settings', { variant: 'error' });
    }
  };
  
  useEffect(() => {
    const fetchSmallSettings = async () => {
      try {
        const res = await axios.post(`${REST_API_END_POINT}print/get-small-label-settings`);
        if (res.data.status === 1) {
          setSmallLabelSettings(prev => ({
            ...prev,
            ...res.data.result
          }));
        }
      } catch (error) {
        enqueueSnackbar('Failed to load settings', { variant: 'error' });
      }
    };
  
    fetchSmallSettings();
  }, [openSmallLabelModal]);
  
  const saveSmallLabelSettings = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}print/update-small-label-settings`, {
        values: smallLabelSettings
      });
      if(res.data.status === 1) {
        setOpenSmallLabelModal(false);
        enqueueSnackbar('Settings saved successfully!', { variant: 'success' });
      }
    } catch (error) {
      enqueueSnackbar('Failed to save small label settings', { variant: 'error' });
    }
  };

  useEffect(() => {
    if (openLabelModal) {
      const timeout = setTimeout(updateIframeContent, 300);
      return () => clearTimeout(timeout);
    }
  }, [openLabelModal, labelSettings]);
  
    

  const handlePrintClick = () => {
    if (printerSettings) {
      setOpenLabelModal(true);
    } else {
      // Trigger direct print
      handlePrint();
    }
  };

  const handleSmallPrintClick = () => {
    if (printerSettings) {
      setOpenSmallLabelModal(true);
    } else {
      // Trigger direct print
      handleSmallPrint();
    }
  };

console.log('descriptiondescription',description)
  return (
    <>
        {useIcon ? 
          <IconButton ref={ref} color='#ffffff' onClick={handlePrintClick}>
            <PrintOutlined />
          </IconButton>
          :
          <>
            <Tooltip title='Print Label'>
              <IconButton ref={ref} color='#ffffff' onClick={handlePrintClick}>
                <PrintOutlined />
              </IconButton>
            </Tooltip>

            <Tooltip title='Print Small Label'>
              <IconButton ref={detailsRef} color='primary' onClick={handleSmallPrintClick}>
                <PrintOutlined />
              </IconButton>
            </Tooltip>
          </>
        }

      
      <div style={{ display: 'none' }}>
        {/* <div ref={componentRef} style={labelStyle}> */}
        <div ref={componentRef} 
        style={{
          position: 'absolute',
          top: `${labelSettings.marginTop}px`,
          left: `${labelSettings.marginLeft}px`,
          transform: `scale(${labelSettings.scale})`,
          transformOrigin: 'top left',
          paddingTop: `${labelSettings.paddingTop}px`,
          paddingRight: `${labelSettings.paddingRight}px`,
          paddingBottom: `${labelSettings.paddingBottom}px`,
          paddingLeft: `${labelSettings.paddingLeft}px`,
          width: `${labelSettings.width}in`,
          height: `${labelSettings.height}in`,
          fontFamily: 'Arial, sans-serif',
          fontSize: '10px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
        >

          <div style={rowStyle}>
            {!empty(barcode) && (
              <>
                <div style={qrCodeSectionNew}>
                  <QRCode
                    value={barcode}
                    size={labelSettings.qrSize}
                    bgColor={'#ffffff'}
                    fgColor={'#000000'}       
                    includeMargin={false}
                  />
                  <Typography variant="caption" sx={{color:'black', textAlign:'center',fontSize:"7px"}}>Material</Typography>
                </div>
              </>
            )}
            
              <div style={sectionStyle}>
                {/* <Typography variant="h5" style={typographyStyle}>{name}</Typography> */}
                <Typography variant="h5" style={{
                  ...typographyStyle,
                  fontSize: `${labelSettings.skuFontSize}px`,
                  fontWeight: 'bold',
                }}>{partial ? 'PARTIAL' : 'WHOLE UNIT'}</Typography>
                {!empty(vpt_number) && (
                  <Typography variant="h5" style={{
                    ...typographyStyle,
                    fontSize: `${labelSettings.skuFontSize}px`
                  }}>SKU# {vpt_number}</Typography>
                )}
                {!empty(description) && (
                  <>
                    {/* Previous code - commented out */}
                    {/* <Typography variant="h5" style={{
                      ...typographyStyleForDesc,
                      fontSize: `${labelSettings.titleFontSize}px`
                    }}>{description}</Typography> */}
                    
                    {/* New code - shows full description without CSS truncation, but truncates after 100 characters */}
                    <Typography variant="h5" style={{
                      fontWeight: 'bold',
                      textAlign: 'center',
                      color: 'black',
                      fontSize: `${labelSettings.titleFontSize}px`,
                      wordWrap: 'break-word',
                      wordBreak: 'break-word',
                      whiteSpace: 'normal',
                      overflow: 'visible',
                    }}>
                      {description && description.length > 100 
                        ? `${description.substring(0, 100)}...` 
                        : description}
                    </Typography>
                  </>
                )}
                {!empty(vendor) && (
                  <Typography variant="h5" style={{
                    ...typographyStyle,
                    fontSize: `${labelSettings.skuFontSize}px`
                  }}>{vendor}</Typography>
                )}
              </div>
            
            {/* <div style={qrCodeSection}>
              <QRCode
                value={`${url}${id}`}
                size={labelSettings.qrSize}
                bgColor={'#ffffff'}
                fgColor={'#000000'}       
                includeMargin={false}
              />
              <Typography variant="caption" sx={{color:'black', textAlign:'center',fontSize:"7px"}}>Details</Typography>
            </div> */}
          </div>
        </div>
      </div>
      <div style={{ display: 'none' }}>
        {/* <div ref={detailsRef} style={{ ...labelStyle1, margin: '0' }}> */}
        <div ref={detailsRef} 
         style={{
          position: 'absolute',
          top: `${smallLabelSettings.marginTop}px`,
          left: `${smallLabelSettings.marginLeft}px`,
          transform: `scale(${smallLabelSettings.scale})`,
          transformOrigin: 'top left',
          paddingTop: `${smallLabelSettings.paddingTop}px`,
          paddingRight: `${smallLabelSettings.paddingRight}px`,
          paddingBottom: `${smallLabelSettings.paddingBottom}px`,
          paddingLeft: `${smallLabelSettings.paddingLeft}px`,
          width: `${smallLabelSettings.width}in`,
          height: smallLabelSettings.height,
          fontFamily: 'Arial, sans-serif',
          fontSize: '8px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          boxSizing: 'border-box',
          overflow: 'hidden',
        }}
          >
          <div>
            <div style={rowStyle1}>
              {!empty(barcode) && (
                <>
                  <div style={qrCodeSection}>
                    <QRCode
                      value={barcode}
                      size={smallLabelSettings.qrSize}
                      bgColor={'#ffffff'}
                      fgColor={'#000000'}       
                      includeMargin={false}
                    />
                    {/* <Typography variant="caption" style={typographyStyle1}>{name}</Typography> */}
                  </div>
                </>
              )}
              {/* <div style={sectionStyle}>
                {!empty(name) && (
                  <Typography variant="h5" style={typographyStyle}>{name}</Typography>
                )}
              </div> */}
              {/* <div style={qrCodeSection}>
                <QRCode
                  value={`${url}${id}`}
                  size={50}
                  bgColor={'#ffffff'}
                  fgColor={'#000000'}       
                  includeMargin={false}
                />
                <Typography variant="caption" sx={{color:'black', textAlign:'center'}}>Scan for Details</Typography>
              </div> */}
            </div>
          </div>
          <Typography variant="caption" style={{
            ...typographyStyle1,
            fontSize: `${smallLabelSettings.smallTitleFontSize}px`,
            fontWeight: 'bold',
            marginBottom: '2px'
          }}
          >{partial ? 'PARTIAL' : 'WHOLE UNIT'}</Typography>
          {/* Previous code - commented out */}
          {/* <Typography variant="caption" style={{
          ...typographyStyle1,
            fontSize: `${smallLabelSettings.smallTitleFontSize}px`
          }}
          >{name}
          </Typography> */}
          
          {/* New code - shows full name without CSS truncation, but truncates after 100 characters */}
          <Typography variant="caption" style={{
            ...typographyStyle1,
            fontSize: `${smallLabelSettings.smallTitleFontSize}px`,
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            whiteSpace: 'normal',
            overflow: 'visible',
          }}>
            {name && name.length > 100 
              ? `${name.substring(0, 100)}...` 
              : name}
          </Typography>
        </div>
      </div>
      <Modal open={openSmallLabelModal} handleClose={() => setOpenSmallLabelModal(false)} modalTitle="Print Settings">
      <Grid
        container
        style={{
          padding: 10,
          width: '100%',
          borderRadius: 8,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Grid container spacing={3} alignItems="flex-start" justifyContent="space-between">
          {/* Inputs section */}
          <Grid item xs={12} sm={5} style={{ padding: 10, borderRadius: 4 }}>
          <Typography variant="body1" fontSize={'14px'} fontWeight={'600'} textAlign={'center'} gutterBottom>
                Adjust Label
              </Typography>
            <Stack spacing={3}>
              <TextField
                fullWidth
                label="Scale"
                type="number"
                inputProps={{ min: 0 }}
                value={smallLabelSettings.scale}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, scale: parseFloat(e.target.value) })}
                step="0.1"
                min="0.1"
                variant="outlined"
                margin="dense"
              />
              <TextField
                fullWidth
                label="QR Code Size"
                type="number"
                inputProps={{ min: 0 }}
                value={smallLabelSettings.qrSize}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, qrSize: parseInt(e.target.value) })}
                variant="outlined"
                margin="dense"
              />
              <Typography variant="body2" fontWeight={400} sx={{ mb: 0 }} gutterBottom>
                Padding
              </Typography>
              <Grid container spacing={1}>
                <Grid item xs={5.5}>
                  <TextField
                    fullWidth
                    label="Top (px)"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={smallLabelSettings.paddingTop}
                    onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, paddingTop: parseInt(e.target.value) })}
                    variant="outlined"
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={5.5}>
                  <TextField
                    fullWidth
                    label="Right (px)"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={smallLabelSettings.paddingRight}
                    onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, paddingRight: parseInt(e.target.value) })}
                    variant="outlined"
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={5.5}>
                  <TextField
                    fullWidth
                    label="Bottom (px)"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={smallLabelSettings.paddingBottom}
                    onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, paddingBottom: parseInt(e.target.value) })}
                    variant="outlined"
                    margin="dense"
                  />
                </Grid>
                <Grid item xs={5.5}>
                  <TextField
                    fullWidth
                    label="Left (px)"
                    type="number"
                    inputProps={{ min: 0 }}
                    value={smallLabelSettings.paddingLeft}
                    onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, paddingLeft: parseInt(e.target.value) })}
                    variant="outlined"
                    margin="dense"
                  />
                </Grid>
              </Grid>
              <Typography variant="body2" fontWeight={400} sx={{ mb: 1 }} gutterBottom>
                Margins
              </Typography>
              <Grid container spacing={1}>
              <Grid item xs={5.5}>
                <TextField
                  fullWidth
                  label="Top (px)"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={smallLabelSettings.marginTop}
                  onChange={(e) =>
                    setSmallLabelSettings({
                      ...smallLabelSettings,
                      marginTop: parseFloat(e.target.value)
                    })
                  }
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={5.5}>
                <TextField
                  fullWidth
                  label="Right (px)"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={smallLabelSettings.marginRight}
                  onChange={(e) =>
                    setSmallLabelSettings({
                      ...smallLabelSettings,
                      marginRight: parseFloat(e.target.value)
                    })
                  }
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={5.5}>
                <TextField
                  fullWidth
                  label="Bottom (px)"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={smallLabelSettings.marginBottom}
                  onChange={(e) =>
                    setSmallLabelSettings({
                      ...smallLabelSettings,
                      marginBottom: parseFloat(e.target.value)
                    })
                  }
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
              <Grid item xs={5.5}>
                <TextField
                  fullWidth
                  label="Left (px)"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={smallLabelSettings.marginLeft}
                  onChange={(e) =>
                    setSmallLabelSettings({
                      ...smallLabelSettings,
                      marginLeft: parseFloat(e.target.value)
                    })
                  }
                  variant="outlined"
                  margin="dense"
                />
              </Grid>
            </Grid>
              {/* <TextField
                fullWidth
                type='number'
                inputProps={{ min: 0 }}
                label="Label Width (in)"
                value={smallLabelSettings.width}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, width: e.target.value })}
                variant="outlined"
                margin="dense"
              />
              <TextField
                fullWidth
                label="Label Height (in)"
                inputProps={{ min: 0 }}
                value={smallLabelSettings.height}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, height: e.target.value })}
                variant="outlined"
                margin="dense"
              /> */}
              <TextField
                fullWidth
                type="number"
                inputProps={{ min: 0 }}
                label="Title Size (px)"
                value={smallLabelSettings.smallTitleFontSize}
                onChange={(e) =>
                  setSmallLabelSettings({
                    ...smallLabelSettings,
                    smallTitleFontSize: parseInt(e.target.value)
                  })
                }
                variant="outlined"
                margin="dense"
              />
              <Grid container spacing={1}>
                <Grid item xs={5.5}>
                  <TextField
                  fullWidth
                  type='number'
                  inputProps={{ min: 0 }}
                  label="Label Width (in)"
                  value={smallLabelSettings.width}
                  onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, width: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
                </Grid>
                <Grid item xs={5.5}>
                <TextField
                  fullWidth
                  type='number'
                  label="Label Height (in)"
                  inputProps={{ min: 0 }}
                  value={smallLabelSettings.height}
                  onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, height: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
                </Grid>
              </Grid>
              </Stack>
          </Grid>

          {/* Preview section */}
          <Grid item xs={12} sm={6} style={{ padding: 10, borderRadius: 4 }}>
          <Typography variant="body1" fontSize={'14px'} fontWeight={'600'} textAlign={'center'} gutterBottom>
                Live Preview
              </Typography>
            <Stack direction={'row'} gap={1} mb={1} >
            {/* <TextField
                fullWidth
                label="Page Width (mm)"
                value={smallLabelSettings.pageWidth}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, pageWidth: e.target.value })}
                variant="outlined"
                margin="dense"
              /> */}
              <TextField
                  fullWidth
                  label="Page Width (in)"
                  type="number"
                  value={smallLabelSettings.pageWidth}
                  onChange={(e) =>
                    setSmallLabelSettings({
                      ...smallLabelSettings,
                      pageWidth: e.target.value
                    })
                  }
                  inputProps={{ min: 0 }}
                  variant="outlined"
                  margin="dense"
                />
              <TextField
                fullWidth
                type="number"
                label="Page Height (in)"
                value={smallLabelSettings.pageHeight}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, pageHeight: e.target.value })}
                inputProps={{ min: 0 }}
                variant="outlined"
                margin="dense"
              />
          </Stack>
            {/* <iframe
            ref={smallIframeRef}
            title="Small Label Preview"
            style={{
              width: '100%',
              height: '600px',
              border: '1px solid #ccc',
            }}
          /> */}
          <Box sx={{ display: 'flex', justifyContent: 'center',mb:2 }}>
            <iframe
              ref={smallIframeRef}
              title="Small Label Preview"
              style={{
                width: iframeWidthSmall < 700 ? `${iframeWidthSmall}px` : '100%',
                height: iframeHeightSmall < 600 ? `${iframeHeightSmall}px` : '600px',
                maxWidth: '100%',
                maxHeight: '600px',
                border: '1px solid #ccc',
                background: '#fff',
                overflow: 'auto',
                display: 'block',
              }}
            />
          </Box>
          {/* <Stack direction={'row'} gap={1} mb={1} >
          <TextField
                fullWidth
                type='number'
                inputProps={{ min: 0 }}
                label="Label Width (in)"
                value={smallLabelSettings.width}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, width: e.target.value })}
                variant="outlined"
                margin="dense"
              />
              <TextField
                fullWidth
                type='number'
                label="Label Height (in)"
                inputProps={{ min: 0 }}
                value={smallLabelSettings.height}
                onChange={(e) => setSmallLabelSettings({ ...smallLabelSettings, height: e.target.value })}
                variant="outlined"
                margin="dense"
              />
              </Stack> */}
          </Grid>
        </Grid>

        {/* Buttons */}
        <Grid item xs={12} style={{ marginTop: 20, textAlign: 'right' }}>
          <Stack direction="row" spacing={2}>
            <ReactToPrint
              trigger={() => (
                <Button variant="contained" color="primary" style={{ padding: '8px 20px' }}>
                  Print
                </Button>
              )}
              content={() => detailsRef.current}
              onBeforeGetContent={() => setOpenSmallLabelModal(false)}
            />
            <Button variant="outlined"  onClick={saveSmallLabelSettings}>
              Save Settings
            </Button>
            <Button variant="outlined" color='error' onClick={() => setOpenSmallLabelModal(false)}>
              Cancel
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Modal>

      {/* Modal for Main Label */}
      <Modal
        open={openLabelModal}
        handleClose={() => {setOpenLabelModal(false)}}
        onClick={(e) => e.stopPropagation()}
        width={700}
        modalTitle={'Print Settings'}
      >
        <Grid
          container
          style={{
            padding: 10,
            width: '100%',
            borderRadius: 8,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <Grid container spacing={3} alignItems="flex-start" justifyContent={'space-between'}>
            {/* Left side: Inputs */}
            <Grid item xs={12} sm={5} style={{ padding: 10, borderRadius: 4 }}>
            <Typography variant="body1" fontSize={'14px'} fontWeight={'600'} textAlign={'center'} gutterBottom>
               Adjust Label
              </Typography>
              <Stack spacing={3}>
                <TextField
                  fullWidth
                  label="Scale"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={labelSettings.scale}
                  onChange={(e) => setLabelSettings({ ...labelSettings, scale: parseFloat(e.target.value) })}
                  step="0.1"
                  min="0.1"
                  variant="outlined"
                  margin="dense"
                />
                <TextField
                  fullWidth
                  label="QR Code Size"
                  type="number"
                  inputProps={{ min: 0 }}
                  value={labelSettings.qrSize}
                  onChange={(e) => setLabelSettings({ ...labelSettings, qrSize: parseInt(e.target.value) })}
                  variant="outlined"
                  margin="dense"
                />
                <Typography variant="body2" fontWeight={400} sx={{ mt: 2, mb: 1 }} gutterBottom>
                  Padding
                </Typography>
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Top (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.paddingTop}
                      onChange={(e) => setLabelSettings({ ...labelSettings, paddingTop: parseInt(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Right (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.paddingRight}
                      onChange={(e) => setLabelSettings({ ...labelSettings, paddingRight: parseInt(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Bottom (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.paddingBottom}
                      onChange={(e) => setLabelSettings({ ...labelSettings, paddingBottom: parseInt(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Left (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.paddingLeft}
                      onChange={(e) => setLabelSettings({ ...labelSettings, paddingLeft: parseInt(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                </Grid>
                <Typography variant="body2" fontWeight={400} sx={{ mt: 2, mb: 1 }} gutterBottom>
                  Margins
                </Typography>
                <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Top (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.marginTop}
                      onChange={(e) => setLabelSettings({ ...labelSettings, marginTop: parseFloat(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Right (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.marginRight}
                      onChange={(e) => setLabelSettings({ ...labelSettings, marginRight: parseFloat(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Bottom (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.marginBottom}
                      onChange={(e) => setLabelSettings({ ...labelSettings, marginBottom: parseFloat(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                      fullWidth
                      label="Left (px)"
                      type="number"
                      inputProps={{ min: 0 }}
                      value={labelSettings.marginLeft}
                      onChange={(e) => setLabelSettings({ ...labelSettings, marginLeft: parseFloat(e.target.value) })}
                      variant="outlined"
                      margin="dense"
                    />
                  </Grid>
                </Grid>

                <TextField
                  fullWidth
                  type="number"
                  inputProps={{ min: 0 }}
                  label="Title Size (px)"
                  value={labelSettings.titleFontSize}
                  onChange={(e) =>
                    setLabelSettings({ ...labelSettings, titleFontSize:parseInt(e.target.value) })
                  }
                  variant="outlined"
                  margin="dense"
                />
                <TextField
                fullWidth
                type="number"
                inputProps={{ min: 0 }}
                label={!empty(vendor) ? "SKU & Vendor Size (px)" : "SKU Size (px)"}
                value={labelSettings.skuFontSize}
                onChange={(e) =>
                  setLabelSettings({ ...labelSettings, skuFontSize: parseInt(e.target.value) })
                }
                variant="outlined"
                margin="dense"
              />
                {/* <Grid container spacing={1} sx={{ mt: 0 }}>
                  <Grid item xs={5.5}>
                    <TextField
                  fullWidth
                  type='number'
                  label="Label Width (in)"
                  value={labelSettings.width}
                  inputProps={{ min: 0 }}
                  onChange={(e) => setLabelSettings({ ...labelSettings, width: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
                  </Grid>
                  <Grid item xs={5.5}>
                    <TextField
                  fullWidth
                  type='number'
                  inputProps={{ min: 0 }}
                  label="Label Height (in)"
                  value={labelSettings.height}
                  onChange={(e) => setLabelSettings({ ...labelSettings, height: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
                  </Grid>
                </Grid> */}
              </Stack>
            </Grid>

            {/* Right side: Real Live Preview */}
            <Grid item xs={12} sm={6} style={{ padding: 10, borderRadius: 4,display:'flex',flexDirection:'column',justifyContent:'center',alignContent:'center' }}>
              <Typography variant="body1" fontSize={'14px'} fontWeight={'600'} textAlign={'center'} gutterBottom>
                Live Preview
              </Typography>
              {/* <iframe
                ref={iframeRef}
                title="Label Preview"
                style={{
                  width: '100%',
                  height: '600px',
                  border: '1px solid #ccc',
                }}
              /> */}
              <Stack direction={'row'} gap={1} mb={1}  >
              <TextField
                fullWidth
                type="number"
                label="Page Width (in)"
                value={labelSettings.pageWidth}
                inputProps={{ min: 0 }}
                onChange={(e) => setLabelSettings({ ...labelSettings, pageWidth: e.target.value })}
                variant="outlined"
                margin="dense"
              />
              <TextField
                fullWidth
                type="number"
                label="Page Height (in)"
                value={labelSettings.pageHeight}
                inputProps={{ min: 0 }}
                onChange={(e) => setLabelSettings({ ...labelSettings, pageHeight: e.target.value })}
                variant="outlined"
                margin="dense"
              />
              </Stack>
              <Box sx={{ display: 'flex', justifyContent: 'center',mb:2 }}>
                <iframe
                  ref={iframeRef}
                  title="Label Preview"
                  style={{
                    width: iframeWidth < 700 ? `${iframeWidth}px` : '100%',
                    height: iframeHeight < 600 ? `${iframeHeight}px` : '600px',
                    maxWidth: '100%',
                    maxHeight: '600px',
                    border: '1px solid #ccc',
                    background: '#fff',
                    overflow: 'auto',
                    display: 'block',
                  }}
                />
              </Box>
              <Stack direction={'row'} gap={1} mb={1}  >
              <TextField
                  fullWidth
                  type='number'
                  label="Label Width (in)"
                  value={labelSettings.width}
                  inputProps={{ min: 0 }}
                  onChange={(e) => setLabelSettings({ ...labelSettings, width: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
              <TextField
                  fullWidth
                  type='number'
                  inputProps={{ min: 0 }}
                  label="Label Height (in)"
                  value={labelSettings.height}
                  onChange={(e) => setLabelSettings({ ...labelSettings, height: e.target.value })}
                  variant="outlined"
                  margin="dense"
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid item xs={12} style={{ marginTop: 20, textAlign: 'right' }}>
            <Stack direction="row" spacing={2}>
            <ReactToPrint
              trigger={() => (
                <Button
                variant="contained"
                color="primary"
                style={{ padding: '8px 20px' }}
              >
                Print
              </Button>
              )}
              content={() => componentRef.current}
              />
              <Button variant="outlined" onClick={saveSettings}>
              Save Settings
            </Button>
              <Button
                variant="outlined"
                color='error' 
                onClick={() => {
                  setOpenLabelModal(false);
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Modal>


    </>
  )
}

FinishedProductmenu.propTypes = {
  id: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  useIcon: PropTypes.bool,
  name: PropTypes.string,
  vpt_number: PropTypes.string,
  partial: PropTypes.bool
};
